// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"310":"9ef401bb","849":"af120a0f"}[chunkId] + ".css";
};